<script setup>
// @ts-check
import SignupForm from './components/Form/SignupForm.vue'

import { provideMasters } from './Master.vue'
import LayoutArea from '@/studentsite/common/components/LayoutArea/LayoutArea.vue'
provideMasters()

/**
 * @import { PropType } from 'vue'
 * @import { ComponentProps } from './propTypes.js'
 */

defineProps({
  inputErrors: {
    /** @type {PropType<ComponentProps["inputErrors"]>} */
    type: Object,
    required: true,
  },
})
</script>

<template>
  <LayoutArea :mode="`simple`">
    <SignupForm :inputErrors="inputErrors" />
  </LayoutArea>
</template>
